"use client";

import { IDashboardMetrics, IUserOrder } from "@/api";
import he from 'he';
import {
    Box,
    Typography,
    Grid,
    Paper,
    IconButton,
    Pagination,
    PaginationItem,
    CircularProgress,
    Link,
    Button,
    CardContent,
    Card,
    CardMedia,
    Menu,
    MenuItem,
    Chip,
  } from "@mui/material";
import {
  CheckCircle,
  CheckSquare,
  ListTodo,
  Medal,
  BookOpen,
  BadgeAlert,
} from "lucide-react";
import { useUserOrderContext } from "./Layout";
import { useCallback, useEffect, useState } from "react";
import PagerTitle from "@/components/PagerTitle";
import { StyledLink } from "@/components/StyledLink";
import { useNavigate } from "react-router";
import { GridColDef } from "@mui/x-data-grid";
import { MenuIcon } from "lucide-react";
import ListingTableTemplate from "@/components/ListingTableTemplate";
import { nonFilterQuickFn } from '@/components/DttTableData';
const statusMap: Record<number, "Approved" | "Inactive" | "Pending" | "Rejected"> = {
    1: 'Approved',
    2: 'Inactive',
    3: 'Pending',
    4: 'Rejected',
};

export interface IUserOrderExtend extends IUserOrder {}

export default function MyOrder() {
    const [rows, setRows] = useState<IUserOrderExtend[]>([]);
    const [count, setCount] = useState(0);
    const { getUserOrder } = useUserOrderContext();
    const [loading, setLoading] = useState(false);
    
    const reloadData = useCallback(() => {
        setLoading(true);
        getUserOrder().then((data) => {
            setRows(data['data']);
            setLoading(false);
        });
    }, [count]);

    useEffect(() => {
        reloadData();
    }, []);

    
    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Order ID', flex: 1 },
        { field: 'itemName', headerName: 'Items', flex: 1,
            renderCell: (params) => {
                return <Link href={params.row.itemLink} target="_blank">{he.decode(params.row.itemName).trim()}</Link>;
            }
        },
        { field: 'itemEmail', headerName: 'Email', flex: 1 },
        { field: 'itemType', headerName: 'Type', flex: 1 },
        {
            field: 'itemBillFileUrl', headerName: 'Receipt', width:90, 
            getApplyQuickFilterFn:nonFilterQuickFn,
            renderCell: (params) => {
                return <Button variant="contained" color="primary" onClick={() => {
                    window.open(params.value, '_blank');
                }}>Preview</Button>;
            }
        },
        {
            field: 'itemStatus', headerName: 'Status', width:120, 
            getApplyQuickFilterFn:nonFilterQuickFn,
            renderCell: (params) => {

                const statusKey = params.value as keyof typeof statusMap;
                return <Chip sx={{display: 'flex', flex:1, justifyContent: 'center'}} 
                    label={statusMap[statusKey]} color={statusMap[statusKey] as any} />;
            }
        },
        { field: 'itemCreatedAt', headerName: 'Created Date', flex: 1 },
    ]

    return (
        <Box
        sx={{
            p: 3,
            bgcolor: "white",
            borderRadius: 2,
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            flex: 1,
        }}
        >
            <ListingTableTemplate
                disableRowSelectionOnClick={true}
                buttonOptions={[
                    { label: 'Reload data' },
                ]}
                pageTitle="My Orders"
                columns={columns}
                rows={rows}
                loading={loading}
                onMenuClick={reloadData}
                sortModel={[{ field: 'id', sort: 'desc' }]}
            />
        </Box>
        
        
    );
}